<div
  class="way-purchase-layout way-purchase-single-wash-layout"
  [class.way-purchase-layout--unavailable]="isUnavailable"
  *ngIf="isVisible && displayVm"
>
  <div *ngIf="isUnavailable" class="way-purchase-layout__unavailable">
    <span class="way-purchase-layout__unavailable-badge">Unredeemable</span>
    <p class="way-purchase-layout__unavailable-reason">{{ unavailableReason }}</p>
  </div>

  <div class="way-purchase-layout__grid">
    <div class="way-purchase-layout__field">
      <label class="way-purchase-layout__label">Customer Name</label>
      <p class="way-purchase-layout__value">{{ displayVm.customerName }}</p>
    </div>
    <div
      class="way-purchase-layout__field"
      [class.way-purchase-layout__plate-field--required]="needsPlateEntry"
    >
      <label class="way-purchase-layout__label" for="way-single-wash-plate">Vehicle License Plate</label>
      <ng-container *ngIf="needsPlateEntry; else singleWashPlateReadonly">
        <input
          matInput
          id="way-single-wash-plate"
          type="text"
          class="way-purchase-layout__plate-input"
          [ngModel]="plateInput"
          (ngModelChange)="onPlateInput($event)"
          [disabled]="plateInputDisabled"
          [class.p-invalid]="!!plateInputError"
          autocomplete="off"
          autocapitalize="characters"
          spellcheck="false"
         
          [attr.aria-invalid]="!!plateInputError"
          [attr.aria-describedby]="plateInputError ? 'way-single-wash-plate-error' : null"
        />
        <small
          *ngIf="plateInputError"
          id="way-single-wash-plate-error"
          class="p-error"
          role="alert"
        >
          {{ plateInputError }}
        </small>
      </ng-container>
      <ng-template #singleWashPlateReadonly>
        <p class="way-purchase-layout__value">{{ displayVm.licensePlate }}</p>
      </ng-template>
    </div>
    <div class="way-purchase-layout__field">
      <label class="way-purchase-layout__label">Package Name</label>
      <p class="way-purchase-layout__value">{{ displayVm.packageName }}</p>
    </div>
    <div class="way-purchase-layout__field">
      <label class="way-purchase-layout__label">Purchased Through</label>
      <p class="way-purchase-layout__value">{{ displayVm.channelLabel }}</p>
    </div>
  </div>
</div>
